import React from 'react';
import { formatPaymentBasis, formatDateTime } from '../../utils/salesOrderRelease';

/**
 * Who released a store job's Sales Order, who approved it and on what payment basis.
 * Renders nothing for jobs that didn't come from an approved Sales Order.
 */
const OrderReleaseInfo = ({ job }) => {
  if (!job || (!job.releasedByName && !job.approvedByName && !job.paymentType && !job.statusBeforeApprovalHold)) return null;
  const basis = formatPaymentBasis(job);
  return (
    <div style={{ fontSize: '0.72rem', marginTop: '4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {job.releasedByName && (
        <div style={{ color: 'var(--text-secondary)' }} title={job.releasedAt ? formatDateTime(job.releasedAt) : ''}>
          👤 Released by <strong>{job.releasedByName}</strong>
        </div>
      )}
      {job.approvedByName && (
        <div style={{ color: '#16a34a' }} title={job.approvedAt ? formatDateTime(job.approvedAt) : ''}>
          ✅ Approved by <strong>{job.approvedByName}</strong>{basis ? ` · ${basis}` : ''}
        </div>
      )}
      {!job.approvedByName && basis && <div style={{ color: '#16a34a' }}>💳 {basis}</div>}
      {job.statusBeforeApprovalHold && (
        <div style={{ color: '#d97706', fontWeight: 600 }}>⏸️ {job.holdReason || 'Awaiting Admin re-approval'}</div>
      )}
    </div>
  );
};

export default OrderReleaseInfo;
